import type { Question } from '../../data/schemas';
import type { ClusterResult } from '../../types/result';
import { Accordion } from '../ui/Accordion';

interface ClusterDetailContentProps {
  cluster: ClusterResult;
  questions: readonly Question[];
  showWeightingDetails: boolean;
  showTitle?: boolean;
}

/** Gemeinsamer Inhalt der Cluster-Detailanalyse, genutzt von Inline-Abschnitt und Modal. */
export function ClusterDetailContent({
  cluster,
  questions,
  showWeightingDetails,
  showTitle = true,
}: ClusterDetailContentProps) {
  return (
    <>
      {showTitle ? (
        <div className="cluster-card__header">
          <h3>{cluster.title}</h3>
          <span className="cluster-card__percentage">{cluster.percentage} %</span>
        </div>
      ) : (
        <p className="cluster-card__percentage">{cluster.percentage} %</p>
      )}
      <p className="pill">{cluster.label}</p>
      <p>{cluster.detail}</p>

      {cluster.opportunities.length > 0 && (
        <div>
          <p>
            <strong>Chancen</strong>
          </p>
          <ul>
            {cluster.opportunities.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      )}

      {cluster.risks.length > 0 && (
        <div>
          <p>
            <strong>Risiken</strong>
          </p>
          <ul>
            {cluster.risks.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      )}

      {showWeightingDetails && (
        <Accordion title="Beteiligte Fragen und Einfluss auf diesen Bereich">
          <ul>
            {cluster.contributingQuestions.map((contribution) => {
              const question = questions.find((q) => q.id === contribution.questionId);
              const weightPercentage = Math.round(contribution.weight * 100);
              return (
                <li key={contribution.questionId}>
                  {question?.title}: {contribution.answerScore} von 2 Punkten (Einfluss auf diesen
                  Bereich: {weightPercentage} %)
                </li>
              );
            })}
          </ul>
        </Accordion>
      )}
    </>
  );
}
